import React from 'react';
import Section from '../Section';

const About: React.FC = () => {
  return (
      <Section id="about" additionalStyles={{ backgroundColor: '#222222' }}>
        <h2>About Us</h2>
        <p>At Rust Reduction, we're passionate about breathing new life into older cars and crafting high-performance machines. Based in Southeast PA, Allen specializes in rust repair, precision welding, and custom builds—from patina'd classics like '62 Biscaynes to turbo LS-swapped trucks. Follow our journey on Instagram @rust_reduction for behind-the-scenes action.</p>
      </Section>
  );
};

export default About;